/**
 * This class contains the logic for working with a PersonProfile like interface; primarily the accessability
 * concerns like focus trapping, escape keys, focus restore ect.
 *
 * It can be extended and used as a parent for tightly coupled components which are ALWAYS PersonProfile based
 * or used as a composite component for components which have optional PersonProfile features.
 */
export class PersonProfile {
    constructor(personProfileWrapper) {
        this.personProfileWrapper = personProfileWrapper;

        const toggle = personProfileWrapper.querySelector(
            '.person-profile__publication-toggle'
        );

        if (toggle) {
            toggle.addEventListener('click', () => {
                this.togglePublications();
            });
        }
    }

    /**
     * Toggle the publication list
     */
    togglePublications() {
        const long =
            this.personProfileWrapper.querySelector('.published--long');
        const short =
            this.personProfileWrapper.querySelector('.published--short');
        const toggle = this.personProfileWrapper.querySelector(
            '.person-profile__publication-toggle span'
        );

        if (long && short) {
            if (long.classList.contains('sr-only')) {
                toggle.innerHTML = 'Show less';
                long.classList.remove('sr-only');
                short.classList.add('sr-only');
            } else {
                toggle.innerHTML = 'Show more';
                short.classList.remove('sr-only');
                long.classList.add('sr-only');
            }
        }
    }
}

export default function _personProfile() {
    // Find all personProfiles and created handler objects
    const personProfiles = document.querySelectorAll('.person-profile');
    personProfiles.forEach((personProfile) => {
        // Create a new item to modify
        const DOMItem = personProfile;

        // Attach the PersonProfile instance to our DOM Item
        if (!DOMItem.personProfile) {
            DOMItem.personProfile = new PersonProfile(personProfile);
        }
    });
}

_personProfile();
